// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard-container {
    font-family: Arial, sans-serif;
    margin: 20px auto;
    max-width: 900px;
    text-align: center;
    color: #333;
  }
  
  .leaderboard-header h1 {
    color: #004d66;
    margin-bottom: 20px;
  }
  
  .leaderboard-message p {
    color: #4caf50;
    font-size: 1.2em;
    margin: 10px 0;
  }
  
  .leaderboard-summary {
    display: flex;
    justify-content: space-around;
    margin: 20px 0;
    background-color: #e6f7ff;
    padding: 10px;
    border-radius: 5px;
  }
  
  .summary-item {
    flex: 1 1;
    text-align: center;
    font-size: 1em;
  }
  
  .leaderboard-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  .leaderboard-table th,
  .leaderboard-table td {
    border: 1px solid #ddd;
    padding: 10px;
  }
  
  .leaderboard-table th {
    background-color: #4caf50;
    color: white;
  }
  
  .leaderboard-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .leaderboard-table tr:hover {
    background-color: #f1f1f1;
  }
  `, "",{"version":3,"sources":["webpack://./src/MyComponents/Activities/SpeedQuizActivity/LeaderBoard.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":[".leaderboard-container {\n    font-family: Arial, sans-serif;\n    margin: 20px auto;\n    max-width: 900px;\n    text-align: center;\n    color: #333;\n  }\n  \n  .leaderboard-header h1 {\n    color: #004d66;\n    margin-bottom: 20px;\n  }\n  \n  .leaderboard-message p {\n    color: #4caf50;\n    font-size: 1.2em;\n    margin: 10px 0;\n  }\n  \n  .leaderboard-summary {\n    display: flex;\n    justify-content: space-around;\n    margin: 20px 0;\n    background-color: #e6f7ff;\n    padding: 10px;\n    border-radius: 5px;\n  }\n  \n  .summary-item {\n    flex: 1;\n    text-align: center;\n    font-size: 1em;\n  }\n  \n  .leaderboard-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n  }\n  \n  .leaderboard-table th,\n  .leaderboard-table td {\n    border: 1px solid #ddd;\n    padding: 10px;\n  }\n  \n  .leaderboard-table th {\n    background-color: #4caf50;\n    color: white;\n  }\n  \n  .leaderboard-table tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  .leaderboard-table tr:hover {\n    background-color: #f1f1f1;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
